import {
    GET_SESSION_TYPES_FAIL,
    GET_SESSION_TYPES_SUCCESS,
    ADD_SESSION_TYPE_SUCCESS,
    ADD_SESSION_TYPE_FAIL,
    UPDATE_SESSION_TYPE_SUCCESS,
    UPDATE_SESSION_TYPE_FAIL,
    DELETE_SESSION_TYPE_SUCCESS,
    DELETE_SESSION_TYPE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    sessionTypes: [],
    error: null,
    loading: true,
    success: false
};

const sessionTypeReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des sessionTypes
        case GET_SESSION_TYPES_SUCCESS:
            return {
                ...state,
                sessionTypes: action.payload, // tableau d'objets session
                loading: false,
                error: null
            };

        case GET_SESSION_TYPES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une sessione
        case ADD_SESSION_TYPE_SUCCESS:
            return {
                ...state,
                sessionTypes: [action.payload, ...state.sessionTypes], // ajoute au début du tableau
                error: null,
                success: true
            };

        case ADD_SESSION_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                 success: false
            };

        // Mise à jour d'une sessione
        case UPDATE_SESSION_TYPE_SUCCESS:
            return {
                ...state,
                sessionTypes: state.sessionTypes.map(sessionType =>
                    sessionType.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet session
                        : session
                ),
                error: null,
                 success: true
            };

        case UPDATE_SESSION_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                 success: false
            };

        // Suppression d'une sessione
        case DELETE_SESSION_TYPE_SUCCESS:
            return {
                ...state,
                sessionTypes: state.sessionTypes.filter(
                    sessionType => sessionType.id !== action.payload
                ),
                error: null
            };


        case DELETE_SESSION_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                success: false 
            };


        default:
            return state;
    }
};

export default sessionTypeReducer;
